import { getAnalytics, isSupported, logEvent, Analytics } from "firebase/analytics";
import { app } from "./firebase";
import type { ToolId } from "../pages/Eszkozok";

// App route → oldalcím. A /eszkozok route-ot az Eszkozok.tsx saját effektje
// írja felül aktív kalkulátoronként, ezért itt csak a lista-nézet alapértelmezett
// címe szerepel (soha nem küldünk érte önálló page_view-t, ld. useRouteAnalytics).
export const ROUTE_TITLES: Record<string, string> = {
  "/fooldal": "Főoldal – GLP Napló",
  "/naplo": "Napló – GLP Napló",
  "/statisztika": "Statisztikák – GLP Napló",
  "/eszkozok": "Eszközök – GLP Napló",
  "/profil": "Profil – GLP Napló",
  "/signup": "Regisztráció – GLP Napló",
  // Nincs önálló React route rá (a bejelentkezetlen catch-all AuthPage login
  // módban jelenik meg), csak virtuális page_path az AuthPage saját effektjéhez.
  "/signin": "Bejelentkezés – GLP Napló",
};

export const DEFAULT_TITLE = "GLP Napló";

// Kalkulátoronkénti, ékezet nélküli, stabil slug a calculator_opened eseményhez.
export const CALCULATOR_SLUGS: Record<ToolId, string> = {
  kattintas: "kattintas-kalkulator",
  plotter: "glp-plotter",
  kalkulator: "dozis-kalkulator",
  microdose: "microdose-tervezo",
  predikator: "suly-predikator",
  titralo: "titralo-tervezo",
  feherje: "feherje-kalkulator",
  kimaradt: "kimaradt-injekcio",
  ar: "ar-vs-fogyas",
};

let analyticsPromise: Promise<Analytics | null> | null = null;

function getAnalyticsInstance(): Promise<Analytics | null> {
  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => (supported ? getAnalytics(app) : null))
      .catch(() => null);
  }
  return analyticsPromise;
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  getAnalyticsInstance().then((analytics) => {
    if (analytics) logEvent(analytics, name, params);
  });
}

export function trackPageView(pagePath: string, pageTitle: string): void {
  trackEvent("page_view", {
    page_path: pagePath,
    page_title: pageTitle,
    page_location: window.location.origin + pagePath,
  });
}
